import {useEffect, useState} from 'react';
import {useMutation} from 'react-query';
import {
    IGeneratePrimaryTermsResponse,
    IGetPrimaryTermsResponse,
} from '../../models/registration.model';
import {
    generatePrimaryTerms,
    GetPrimaryTerms,
} from '../../services/registration.service';
import AdditionalInfo from '../additionalInfo/additionalInfo';
import DrawerBody from '../requestSteps/drawerBody/drawerBody';
import {IFormInnerState} from '../requestSteps/form/IFormInnerState';
import BasicInformation from './basicInformation';
import LayoutWithoutDrawer from '../../layouts/LayoutWithoutDrawer';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {useLocation, useNavigate} from 'react-router-dom';

export default function BasicInforContainer({
    setStep,
    referenceKey,
    back,
}: IFormInnerState) {
    const navigate = useNavigate();
    const location = useLocation();
    const [content, setContent] = useState<IGetPrimaryTermsResponse>();
    const loanCalculationResult = useSelector(
        (state: RootState) => state.loanCalculationResult
    );

    const {mutate: GetPrimaryTermsMutate, isLoading} = useMutation(
        GetPrimaryTerms,
        {
            onSuccess: (data: IGetPrimaryTermsResponse) => {
                navigate('/loans/request/additionalInfo', {replace: true});
                setContent(data);
            },
        }
    );
    const {mutate: GeneratePrimaryTermsMutate} = useMutation(
        generatePrimaryTerms,
        {
            onSuccess: (data: IGeneratePrimaryTermsResponse) => {
                navigate('/loans/request/additionalInfo', {replace: true});
                setContent(data);
            },
        }
    );

    useEffect(() => {
        if (referenceKey) {
            GetPrimaryTermsMutate({referenceKey: referenceKey!});
        } else {
            GeneratePrimaryTermsMutate({
                financialSupplier: loanCalculationResult.financialSupplier,
                loanAmount: loanCalculationResult.loanAmount,
                loanTemplateId: loanCalculationResult.loanTemplateId,
                organizationId: loanCalculationResult.organizationId,
                stepSpaceId: loanCalculationResult.stepSpaceId,
            });
        }
    }, []);
    const setInnerState = (state: 'additionalInfo' | 'basickInfo') => navigate(`/loans/request/${state}`);
    if (location.pathname.endsWith('/basickInfo')) return <DrawerBody>
        <BasicInformation setStep={setStep} referenceKey={referenceKey!} back={back} />
    </DrawerBody>;
    return <LayoutWithoutDrawer>
                <AdditionalInfo
                    referenceKey={referenceKey!}
                    setInnerState={setInnerState}
                    setStep={setStep}
                    content={content!}
                    primaryTermsServiceLoading={isLoading}
                />
                ,
    </LayoutWithoutDrawer>;
}
